import React from "react";
import PropTypes from 'prop-types';
import { HexColorPicker } from "react-colorful";
import { IconButton, Tooltip } from "@mui/material";
import ColorLensIcon from '@mui/icons-material/ColorLens';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import './Colors.css';

Colors.propTypes = {
    onColorAdd: PropTypes.func,
    colors: PropTypes.array,
    onNameChange: PropTypes.func,
    onColorChange: PropTypes.func,
    editedColor: PropTypes.object,
    onColorEdit: PropTypes.func,
    onColorSelect: PropTypes.func,
    selectedColor: PropTypes.object,
    onColorDelete: PropTypes.func,
}

function renderColorControls(c, props) {
    return c.map((color, index) => {
        const className = `color${color.id === props.selectedColor.id ? ' selected' : ''}`;
        return (
            <div key={index} className={className}>
                <Tooltip title="Farbe bearbeiten" arrow placement="right">
                    <ColorLensIcon style={{ cursor: "pointer" }} onClick={() => props.onColorEdit(color)} />
                </Tooltip>
                <p className="color-indicator" style={{ backgroundColor: color.color }} onClick={() => props.onColorSelect(color)} />
                <input className="color-name" type="text" value={color.name} onChange={(e) => props.onNameChange(color, e.target.value)} />
                <Tooltip title="Farbe löschen" arrow placement="right">
                    <DeleteIcon style={{ cursor: "pointer" }} onClick={() => props.onColorDelete(color)} />
                </Tooltip>
            </div>
        );
    });
}

export function Colors(props) {
    const { colors, editedColor, onColorEdit, onColorChange, onColorAdd } = props;

    return (
        <div>
            <div className="colors">
                <p className="color-title">Farben</p>
                {renderColorControls(colors, props)}
                {editedColor !== null && (
                    <>
                        <div className="backdrop" onClick={() => onColorEdit(null)}></div>
                        <div className="color-picker" style={{ top: colors.length * -30 + editedColor.id * 30 - 5 }}>
                            <HexColorPicker color={editedColor.color} onChange={onColorChange} />
                        </div>
                    </>
                )}
                <div className="color-controls">
                    <Tooltip title="Farbe hinzufügen" arrow placement="right">
                        <IconButton size="small" onClick={onColorAdd}><AddCircleOutlineIcon /></IconButton>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
}
